module.exports = __webpack_public_path__ + "img/1@s.a5508e4e.jpg";